const config = (window as any)._app_;

const AppConfig = {
    baseUrl: config.BASE_URL,
    baseTabTitle: config.BASE_TAB_TITLE,
    apiPath: config.API_PATH,
};

export default AppConfig;